import { memo } from 'react';
import HeaderContent from './header-content';

const PublicHeader = () => <HeaderContent />;

export default memo(PublicHeader);
